import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
class NotificationService {
  showErrorPopup(
    title: string = 'Hata!',
    text: string = 'Bir şeyler ters gitti! Lütfen tekrar deneyiniz.',
    confirmButtonText: string = 'Tamam'
  ) {
    let popup = withReactContent(Swal)

    return popup.fire({
      icon: 'error',
      title: title,
      text: text,
      confirmButtonText: confirmButtonText,
    })
  }

  showUnauthorizedRedirectionPopup(
    interval: number = 10000,
    titleText: string = 'Lütfen tekrar giriş yapınız!',
    warningText: string = 'Uzun süredir işlem yapmadığınız için '
  ) {
    let popup = withReactContent(Swal)
    let timerInterval
    return popup.fire({
      title: titleText,
      icon: 'warning',
      html:
        warningText +
        '<b></b> saniye içerisinde giriş ekranına yönledirileceksiniz...' +
        '<br />' +
        `<button id="logOutNowBtn" class="p-button" style="margin-top: 15px;">Giriş ekranına yönlendir</button>`,
      timer: interval,
      allowOutsideClick: false,
      timerProgressBar: true,
      confirmButtonText: 'Giriş ekranına git',
      didOpen: () => {
        Swal.showLoading(undefined)
        if (Swal.getHtmlContainer()) {
        }
        const b = Swal.getHtmlContainer()?.querySelector('b')
        const logOutNowBtn = Swal.getHtmlContainer()?.querySelector('#logOutNowBtn')
        logOutNowBtn?.addEventListener('click', (e) => {
          Swal.clickConfirm()
        })
        //this timer updates ui.
        timerInterval = setInterval(() => {
          let timerLeft = Swal.getTimerLeft()
          if (b != null && timerLeft != null) b.textContent = String(Math.round(timerLeft / 1000))
        }, 100)
      },
    })
  }

  showCustomPopup(
    text: string,
    icon: string | any = 'info',
    title: string = 'Uyarı!',
    confirmButtonText: string = 'Tamam'
  ) {
    let popup = withReactContent(Swal)
    return popup.fire({
      icon: icon,
      title: title,
      text: text,
      confirmButtonText: confirmButtonText,
    })
  }

  showCustomHtmlPopup(
    html: string,
    icon: string | any = 'info',
    title: string = 'Uyarı!',
    confirmButtonText: string = 'Tamam',
    showDenyButton: boolean = false,
    denyButtonText: string = 'İptal'
  ) {
    let popup = withReactContent(Swal)

    return popup.fire({
      icon: icon,
      title: title,
      html: html,
      confirmButtonText: confirmButtonText,
      showDenyButton: showDenyButton,
      denyButtonText: denyButtonText,
    })
  }
}

export default new NotificationService()
